window.theme = window.theme || {};

theme.config = {
  mqlSmall: false,
  mediaQuerySmall: 'screen and (max-width: 749px)',
  isTouch:
    'ontouchstart' in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
};

// Init section function when it's visible, then disable observer
theme.initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

class ImageComparison extends HTMLElement {
  constructor() {
    super();
    this.active = false;
    this.button = this.querySelector('button');
    this.horizontal = this.dataset.layout === 'horizontal';
    this.init();
    theme.initWhenVisible({
      element: this.querySelector('.image-comparison__animate'),
      callback: this.animate.bind(this),
      threshold: 0,
    });
  }

  animate() {
    this.setAttribute('animate', '');
    this.classList.add('animating');
    setTimeout(() => {
      this.classList.remove('animating');
    }, 1e3);
  }

  init() {
    if (theme.config.isTouch) {
      this.button.addEventListener('touchstart', this.startHandler.bind(this));
      document.body.addEventListener('touchend', this.endHandler.bind(this));
      document.body.addEventListener('touchmove', this.onHandler.bind(this));
    } else {
      this.button.addEventListener('mousedown', this.startHandler.bind(this));
      document.body.addEventListener('mouseup', this.endHandler.bind(this));
      document.body.addEventListener('mousemove', this.onHandler.bind(this));
    }
  }

  startHandler() {
    this.active = true;
    this.classList.add('scrolling');
  }

  endHandler() {
    this.active = false;
    this.classList.remove('scrolling');
  }

  onHandler(e) {
    if (!this.active) return;

    const event = (e.touches && e.touches[0]) || e;
    const x = this.horizontal
      ? event.pageX - this.offsetLeft
      : event.pageY - this.offsetTop;

    this.scrollIt(x);
  }

  scrollIt(x) {
    const distance = this.horizontal ? this.clientWidth : this.clientHeight;

    const max = distance - 20;
    const min = 20;
    const mouseX = Math.max(min, Math.min(x, max));
    const mousePercent = (mouseX * 100) / distance;
    this.style.setProperty('--percent', mousePercent + '%');
  }
}
customElements.define('image-comparison', ImageComparison);

const API = 'https://api.myulike.com';

// seo 优化
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

// 用户自定义js公共库
function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isMobileUserAgent = /Android|iPhone|iPad|iPod|BlackBerry/i.test(
    userAgent
  );
  const maxMobileWidth = 768; // 常用的移动设备屏幕最大宽度
  return isMobileUserAgent && window.innerWidth <= maxMobileWidth;
}
/**
 * GTM 增加GA事件
 * @param {*} category
 * @param {*} operating
 * @param {*} label
 */
function commonGtmEvent(category, operating, label) {
  if (operating == 'true' && isMobile()) {
    category = `M-${category}`
  }
  dataLayer.push({ event: 'common', category, operating, label });
}
/**
 * 获取cookie
 * @param {名称} name
 * @returns
 */
function getCookie(name) {
  const cookieName = name + '=';
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
}

/**
 * 设置cookie
 * @param {string} cookieName - cookie的名称
 * @param {string} cookieValue - cookie的值
 * @param {number} daysToExpire - cookie的过期天数，默认为0，表示永不过期
 */
function setCookie(cookieName, cookieValue, daysToExpire, endOfDay = false) {
  var expires = '';
  if (daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    if (endOfDay) {
      date.setHours(00, 00, 00, 000); // 设置为那天的第一秒
    }
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = cookieName + '=' + cookieValue + expires + '; path=/';
}

/**
 * 清除指定名称的cookie。
 * @param {string} name 需要清除的cookie的名称。
 * 该函数没有返回值。
 */
function clearCookie(name) {
  // 设置cookie的值为空，并设置过期时间为0，以实现清除cookie的效果
  document.cookie = name + '=; max-age=0; path=/';
}

/**
 *  公用初始化方法
 */
function init() {
  // seo 解决图片
  // 获取所有 <video> 标签中的 <img> 标签
  const videoImages = document.querySelectorAll('video img');
  // 遍历所有的 <img> 标签，并设置 alt 属性
  videoImages.forEach((img) => {
    img.setAttribute('alt', 'video image');
    img.setAttribute('loading', 'lazy');
  });

  // 处理全局折扣码
  const urlParams = new URLSearchParams(window.location.search);
  let gDiscount = urlParams.get('discount');
  if (gDiscount) {
    autoDiscountCode(gDiscount);
  }
}

/**
 * 公共 GA代码添加方法
 */
function initGA() {
  // 导航
  $(document).on(
    'click',
    '#shopify-section-announcement-bar .announcement-bar__message a',
    function () {
      let _title = $(this).text();
      if (_title == 'Learn more') {
        commonGtmEvent('首页-90 learn', 'click', _title);
      } else {
        commonGtmEvent('首页-free shop', 'click', _title);
      }
    }
  );
  // logo
  $(document).on('click', '.header__logo-link', function () {
    commonGtmEvent('header__logo-link', 'click', 'logo');
  });

  // 新导航添加事件
  $(document).on('click', '#desktop-menu-1 .header-new-operate-btn, #mobile-menu-1 .header-new-operate-btn', function () {
    commonGtmEvent('导航-Sale', 'true', location.pathname);
  });

  $(document).on('click', '#desktop-menu-2 .header-new-product-item, #mobile-menu-2  .header-new-product-item', function () {
    let index = $('#desktop-menu-2 .header-new-product-item').index(this);
    console.log(index);
    if (isMobile()) {
     index = $('#mobile-menu-2 .header-new-product-item').index(this);
    }
    switch(index){
      case 0:
        commonGtmEvent('导航-air10', 'true', location.pathname);
        break;
      case 1:
        commonGtmEvent('导航-air3', 'true', location.pathname);
        break;
      case 2:
        commonGtmEvent('导航-airX', 'true', location.pathname);
        break;
      case 3:
        commonGtmEvent('导航-reglow', 'true', location.pathname);
        break;
    }
  });

  $(document).on('click', '#desktop-menu-4 .header-new-link-item, #mobile-menu-4 .header-new-link-item', function (e) {
    const linkText = $(this).attr('text').trim();
    commonGtmEvent('导航-explore more-' + linkText, 'true', location.pathname);
  });

  $(document).on('click', '.header .header__linklist-link, #mobile-menu-drawer .mobile-nav .mobile-nav__link', function () {
    const index = $(this).parent().index();
    const mIndex = $('#mobile-menu-drawer .mobile-nav .mobile-nav__link').index(this);
    const linkText = $(this).attr('text');
    if (!linkText){
      return false;
    }

    if (!isMobile() && index != 0){
      commonGtmEvent('导航-'+ linkText, 'true', location.pathname);
    } else if(mIndex != 0) {
      commonGtmEvent('导航-'+ linkText, 'true', location.pathname);
    }

  });

  $(document).on('click', '#desktop-menu-5 .header-new-link-item,#mobile-menu-5 .header-new-link-item', function (e) {
    const linkText = $(this).attr('text').trim();
    commonGtmEvent('导航-Explore More-' + linkText, 'true', location.pathname);
  });

  $(document).on('click', '.header .popover-button', function (e) {
    commonGtmEvent('导航-english', 'true', location.pathname);
  });
  
  // 搜索
  $(document).on('click', '.header .j-search', function () {
    commonGtmEvent('导航-search', 'true', 'search');
  });
  $(document).on('click', '.header .j-cart', function () {
    commonGtmEvent('导航-add cart', 'true', 'cart');
  });
  // 登录
  $(document).on('click', '.header .j-user-login', function () {
    commonGtmEvent('导航-login', 'true', 'wishlist');
  });
  


  $(document).on('click', '#AddToCart', function () {
    // AB 埋点
    window._conv_q = window._conv_q || [];
    _conv_q.push(['triggerConversion', '100476462']);
    commonGtmEvent(`${g_product_name} Product-add to cart`, '', 'Product');
  });

  // banner
  $(document).on('click', '.slideshow__slide-list .button-wrapper .home-btn', function () {
    var i = 1,
      index = 1;
    $('.slideshow__progress-bar').each(function () {
      if ($(this).attr('aria-current') == 'true') {
        index = i;
        return;
      }
      i++;
    });
      // 判断是第一个按钮还是第二个按钮
    const btnIndex = $(this).hasClass('home-btn') ? $(this).index('.home-btn') : -1;
    console.log('按钮索引:', btnIndex, '当前索引:', index);
    // if (index == 1) {
    //   commonGtmEvent(`首页-banner${index}-buy amazon`, 'click', '');
    // } else {
    commonGtmEvent(`首页-banner${index}`, 'click', '');
    // }
  });
  $(document).on(
    'click',
    '.product-area-list .product-area-item:eq(0) .product-area-btn-item:eq(0)',
    function () {
      commonGtmEvent('首页-air10-learn more', 'click', '');
    }
  );
  $(document).on(
    'click',
    '.product-area-list .product-area-item:eq(0) .product-area-btn-item:eq(1)',
    function () {
      commonGtmEvent('首页-air10-shop now', 'click', '');
    }
  );
  $(document).on(
    'click',
    '.product-area-list .product-area-item:eq(1) .product-area-btn-item:eq(0)',
    function () {
      commonGtmEvent('首页-air3 learn more', 'click', '');
    }
  );
  $(document).on(
    'click',
    '.product-area-list .product-area-item:eq(1) .product-area-btn-item:eq(1)',
    function () {
      commonGtmEvent('首页-air3 shop now', 'click', '');
    }
  );
  $(document).on(
    'click',
    '.media-evaluation-real-box .media-real-bottom-arrow-item',
    function () {
      commonGtmEvent('首页-review swith', 'click', '');
    }
  );
  $(document).on('click', '.sub-activity-left .sub-activity-btn', function () {
    commonGtmEvent('首页- marketing banner1', 'click', '');
  });
  $(document).on(
    'click',
    '.sub-activity-right .sub-activity-btn:eq(0)',
    function () {
      commonGtmEvent('首页- marketing banner2', 'click', '');
    }
  );
  $(document).on(
    'click',
    '.sub-activity-right .sub-activity-btn:eq(1)',
    function () {
      commonGtmEvent('首页- marketing banner3', 'click', '');
    }
  );
  // blog
  $(document).on('click', '.blog-info-cont .blog-info-left', function () {
    commonGtmEvent('首页-blog1', 'click', '');
  });
  $(document).on('click', '.blog-info-list .blog-info-item', function () {
    var index = $('.blog-info-list .blog-info-item').index($(this)) + 2;
    commonGtmEvent(`首页-blog${index}`, 'click', '');
  });
  // 订阅
  $(document).on('click', '.footer__top .btn-ico', function () {
    commonGtmEvent('首页-bottom subscription', 'click', '');
  });

  $(document).on('click', '.footer__top .social-media__item', function () {
    let index = $(this).index();
    let name = '首页-ins';
    switch (index) {
      case 0:
        name = '首页-fb';
        break;
      case 1:
        name = '首页-tw';
        break;
      case 2:
        name = '首页-ins';
        break;
      case 3:
        name = '首页-youtube';
        break;
      case 4:
        name = '首页-tt';
        break;
    }
    commonGtmEvent(name, 'click', '');
  });

  $(document).on('click', '.footer__item-list .link--faded', function () {
    let _title = $(this).text();
    commonGtmEvent(`首页-bottom ${_title}`, 'click', '');
  });

  $(document).on('click', '.checkout-button', function () {
    commonGtmEvent(`结账-check out`, 'click', location.pathname);
    window._conv_q = window._conv_q || [];
    _conv_q.push(['triggerConversion', '100476463']);
  });

  $(document).on('click', '.brand-video .brand-video-btn', function () {
    // 找到最近的 .brand-video-item 并获取 data-swiper-slide-index 的值
    let slideIndex = $(this).closest('.brand-video-item').attr('data-swiper-slide-index') + 1;
    // 触发 GTM 事件并传递 slideIndex
    commonGtmEvent(`首页-视频点击-${slideIndex}`, 'click', location.pathname, slideIndex);
  });

  $(document).on('click', '.account-list .header-logout', function (e) {
      e.preventDefault(); // 阻止默认跳转行为
      localStorage.removeItem('userInfo');
      fetch("https://api.ulike.com/user/logout", {
        headers: {
          accept: "application/json, text/plain, */*",
          "content-type": "application/json",
          "x-requested-with": "XMLHttpRequest"
        },
        referrer: "https://account.ulike.com/",
        referrerPolicy: "strict-origin-when-cross-origin",
        method: "GET",
        mode: "cors",
        credentials: "include"
      })
      .then(response => {
        // 可根据 response.status 判断是否登出成功
        if (response.ok) {
          // 跳转到目标链接，比如首页或登录页
          window.location.href = $(this).attr('href') || '/';
        } else {
          console.error('Logout failed');
        }
      })
      .catch(error => {
        console.error('Logout error:', error);
      });
  });

  // 根据指定页面监听事件
  if (location.pathname == '/pages/treatment-tracker') {
    let _temp = isMobile() ? 'M-' : '';
    $(document).on(
      'click',
      '.treatment-tracker-banner .button-wrapper a',
      function () {
        commonGtmEvent(`${_temp}reminder_join`, isMobile(), location.pathname);
      }
    );
    $(document).on('click', '.january-two .btn-txt', function () {
      commonGtmEvent(`${_temp}reminder_sign up`, isMobile(), location.pathname);
    });

    $(document).on('click', '.review-product .review-product-btn', function () {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100481517" ]);
    });

    $(document).on('click', '.results-reviews-product-module .results-reviews-product-add-btn', function () {
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "100481517" ]);
    });
  }

  if (location.href == 'https://www.ulike.com/') {
    $('.refer-friend-container .join-button').on('click', function () {
      commonGtmEvent(`老带新，导流，首页点击`, isMobile(), location.pathname);
    })
    $('.product-area-first .product-area-btn-item').on('click', function () {
      commonGtmEvent(`首页-A10-buy amazon`, isMobile(), location.pathname);
    })
  }
 
  $(document).on('click', '.product-form__button .button', function (e) {
    commonGtmEvent("buy on amazon", isMobile(), location.pathname);
  });

  // 移除优惠券 刷新购物车
  document.body.addEventListener('docapp-discount-code-remove', (e) => {
    console.log('Code is being removed');
    setTimeout(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: false,
        })
      );
    }, 2400);
  });
}


document.addEventListener('DOMContentLoaded', function () {
  init();
  setTimeout(initGA, 1000);
});

/**
 * 从URL中获取指定参数的值
 * @param {string} paramName 需要获取的参数名
 * @return {string|null} 如果找到指定参数，则返回其值；否则，返回null
 */
function getUrlParameter(paramName) {
  // 创建一个URLSearchParams对象，用于解析URL中的查询参数
  const params = new URLSearchParams(window.location.search);
  // 使用指定的参数名获取参数值并返回
  return params.get(paramName);
}

/**
 * 发送请求函数
 * @param {string} url - 请求的URL
 * @param {string} method - 请求方法，默认为'GET'
 * @param {object} data - 请求的数据，默认为null
 * @returns {Promise} - 返回一个Promise对象
 */
function makeRequest(url, method = 'GET', data = null) {
  return new Promise((resolve, reject) => {
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      cache: 'no-cache',
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    fetch(url, options)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP错误！状态码：${response.status}`);
        }
        return response.json();
      })
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
}

/**
 * 验证邮箱格式是否正确
 * @param {string} email - 待验证的邮箱地址
 * @returns {boolean} - 返回true表示邮箱格式正确，返回false表示邮箱格式错误
 */
function validateEmail(email) {
  // 邮箱正则表达式
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // 使用正则表达式测试邮箱格式是否正确
  return emailRegex.test(email);
}

// 复制code
function copyTextFallback(text) {
  if (navigator.clipboard) {
    // 确保运行在安全上下文（如 HTTPS）下才能使用 Clipboard API
    navigator.clipboard.writeText(text);
  } else {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // 使文本框不可见
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      console.log('复制成功:', text);
    } catch (err) {
      console.error('复制失败:', err);
    }
    document.body.removeChild(textArea); // 删除临时文本框
  }
}

/**
 * 自动应用折扣码函数
 * 该函数用于检查当前购物车中已应用的折扣码，如果存在与预设折扣码相似的代码，则移除该代码并应用新的折扣码。
 * @param {string} code - 需要应用的新折扣码
 */
function autoDiscountCode(code) {
  let ulikeCode = [
    'VVBPV0VS',
    'SE9MSURBWQ==',
    'VkRBWTI0',
    'MTBZZWFycw==',
    'UHJpbWVEZWFs',
    'TUVNREFZODA=',
    'TU9NUzgw',
    'QUlSMTBFQVJMWQ==',
    'TkVXNjA=',
  ];
  checkObject(window.discountOnCartProApp, function () {
    let cartCodeArr = window.discountOnCartProApp.codes;
    if (cartCodeArr.length < 1) {
      window.discountOnCartProApp.applyCode(code);
      // 应用优惠劵
      window.discountOnCartProApp.updateWidgets();
    } else {
      var flag = ulikeCode.some((item) => cartCodeArr.includes(atob(item)));
      console.log(flag);
      if (flag) {
        window.discountOnCartProApp.removeCode(
          cartCodeArr[cartCodeArr.length - 1]
        );
        window.discountOnCartProApp.applyCode(code);
      }
    }
    setTimeout(function () {
      window.discountOnCartProApp.updateWidgets();
    }, 3000);
  });
}

function checkObject(obj, callback) {
  if (window.discountOnCartProApp) {
    // 对象存在，执行回调函数
    callback();
  } else {
    // 对象不存在，1秒后再次检查
    setTimeout(() => checkObject(window.discountOnCartProApp, callback), 1000);
  }
}

function scrollToElement(targetId) {
  var targetElement = $('#' + targetId);

  if (targetElement.length) {
    // 滚动到目标元素
    $('html, body').animate(
      {
        scrollTop: targetElement.offset().top - 100, // 减去100像素的偏移量
      },
      1000
    );
  } else {
    // 如果目标元素不存在，滚动到页面顶部
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      1000
    );
  }
}

/**
 * 订阅API函数
 * 该函数用于向指定的API发送订阅请求
 *
 * @param {string} email - 用户的电子邮件地址，用于订阅
 * @param {string} tag - 订阅的标签，用于指定订阅的内容类型
 */
function subscriptionApi(email, tag,type) {
  let data = {
    userEmail: email,
    userPhone: '',
    since: type || 'USER_SUBSCRIBE',
    tags: [tag],
  };
  return sendUlikeApi('/user/userSubscribe', data);
}

function subscriptionApiNew(email, tag,type) {
  let data = {
    userEmail: email,
    userPhone: '',
    scene: type || 'USER_SUBSCRIBE',
    tags: [tag],
  };
  return sendUlikeApi('/user/userSubscribe', data);
}

function sendUlikeApi(url, data) {
  // api.myulike.test  测试环境 手动打开一下
  // api.ulike.com  正式环境
  // 'https://api.myulike.com';  老接口
  data.siteCode = 'US';
  var _url = 'https://api.ulike.com' + url;
  data.language = window.Shopify.locale;

  data.requestId = generateGUID();
  // Set up the AJAX settings
  var settings = {
    url: _url,
    method: 'POST', // POST is used as the request method
    headers: {
      'Content-Type': 'application/json', // Request payload is in JSON format
    },
    data: JSON.stringify(data), // Convert data object to JSON string
    xhrFields: {
      withCredentials: true, // Allow cookies and credentials to be sent
    },
  };

  // Return a new Promise
  return new Promise((resolve, reject) => {
    $.ajax(settings)
      .done(function (response) {
        resolve(response); // Resolve the promise with the response
      })
      .fail(function (error) {
        console.error('Error during API call:', error); // Log the error
        reject(error); // Reject the promise with the error
      });
  });
}

function generateGUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  );
}

/**
 * 手机号码验证
 * @param {号码} number
 * @returns
 */
function validatePhoneNumber(number) {
  const regex = /^(\+|00)?[\d\s-]{0,4}?[\s-]?(\(?\d+\)?[\s-]?){1,6}\d+$/;
  return regex.test(number);
}

function loadCSS(href) {
  let link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.media = "all"; // 使其立即生效
  link.fetchPriority = "low"; // 低优先级加载
  document.head.appendChild(link);
}